import React, { Component } from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import OrderSheetsWidget from './OrderSheetsWidget';
import { HomeRestaurantProps } from '../../connected/HomeRestaurantCnn'
import { withRouter } from 'react-router';
import LogoAndTitle from '../../../Layout/components/LogoAndTitle';
import HistoricalOrdersCnn from '../../connected/HistoricalOrdersCnn';


class HomeRestaurant extends Component<HomeRestaurantProps> {
    componentWillMount() {
        this.props.getAllOrderSheets()
    }
    
    render() {
        return (
            <Grid container>
                <Grid item sm={12} >
                    <LogoAndTitle title="Your order sheets" />

                    {!this.props.orderSheetsBusy && this.props.orderSheets ?
                        <OrderSheetsWidget orderSheets={this.props.orderSheets} setCurrentOrderSheet={this.props.setCurrentOrderSheet} />
                        :
                        <div style={{ textAlign: 'center' }} >
                            <CircularProgress size={50} />
                        </div>
                    }

                    <hr />
                    <br />

                </Grid>
                <Grid item xs={12} sm={12} >
                    <HistoricalOrdersCnn mode="widget"></HistoricalOrdersCnn>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(HomeRestaurant);